import { useTranslation } from 'react-i18next';
import Alert from 'Components/Molecules/Alert/Alert';
import Button from 'Components/Atoms/Button/Button';
import OutlineArrowRight from 'Components/Atoms/OutlineIcons/OutlineArrowRight';
import {deleteProjectWorkspaceSelectedFakeData} from "Services/user.js";
import {useErrors} from "Components/Organisms/ErrorsProvider";
import {useQueryClient} from "@tanstack/react-query";
import {useState} from "react";
import useWorkspaceSelected from "../../../Hooks/useWorkspaceSelected.js";

export default function AppLayoutNoticesFakeData() {
    const { showUnknownError } = useErrors();
    const queryClient = useQueryClient();
    const { workspace, isLoading } = useWorkspaceSelected();

    const [processing, setProcessing] = useState(false);

    const { t } = useTranslation('onboarding');
    if (isLoading || workspace.is_fake_data_removed) return null;

    const handleFakeDataDelete = async () => {
        setProcessing(true);

        try {
            await deleteProjectWorkspaceSelectedFakeData();
            await new Promise((resolve) => setTimeout(resolve, 10000));
            await queryClient.invalidateQueries();
        } catch (error) {
            showUnknownError(error);
        } finally {
            setProcessing(false);
        }
    }

    return (
        <>
            <Alert
                title={t('this-is-fictional-data')}
                description={t('fake-data-description')}
                classNameIcon="bg-warning/10"
                icon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" fill="none" viewBox="0 0 28 26">
                        <path
                            fill="url(#paint0_linear_4003_6548)"
                            fillRule="evenodd"
                            d="M12.289 2.008 2.276 18.976a1.98 1.98 0 0 0 0 2.016A2.07 2.07 0 0 0 4.06 22h20.024c.736 0 1.416-.384 1.784-1.008a1.98 1.98 0 0 0 0-2.016L15.856 2.008A2.07 2.07 0 0 0 14.073 1c-.736 0-1.416.384-1.784 1.008"
                            clipRule="evenodd"
                        ></path>
                        <path
                            fill="#fff"
                            fillRule="evenodd"
                            d="M14.073 6.872c-.716 0-1.295.58-1.295 1.295v5.134a1.295 1.295 0 1 0 2.59 0V8.167c0-.715-.58-1.295-1.296-1.295m0 12.043c.715 0 1.294-.567 1.294-1.267s-.58-1.267-1.295-1.267-1.294.567-1.294 1.267.58 1.267 1.294 1.267"
                            clipRule="evenodd"
                        ></path>
                        <defs>
                            <linearGradient
                                id="paint0_linear_4003_6548"
                                x1="13.949"
                                x2="-6.636"
                                y1="-9.178"
                                y2="14.488"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="#FFBB6D"></stop>
                                <stop offset="1" stopColor="#FF8A00"></stop>
                            </linearGradient>
                        </defs>
                    </svg>
                }
                actions={[
                    <Button variant="primary" isBusy={processing} onClick={handleFakeDataDelete} key="add-bank">
                        {t('fake-data-cta')}
                        <OutlineArrowRight />
                    </Button>,
                ]}
            />
        </>
    );
}
